import { Box, Center, Flex, Stack } from 'styled-system/jsx';
import useAcceptFileMutation from '@/modules/FileList/hooks/useAcceptFileMutation.ts';
import Typography from '@/common/components/base/typography/Typography.tsx';
import Button from '@/common/components/base/button/Button.tsx';
import LoadingButton from '@/common/components/base/button/loadingButton.tsx';
import CheckIcon from '@/common/assets/icons/greenCheckIcon.svg?react';
import BulletTypography from '@/common/components/base/typography/BulletTypography.tsx';
import { useQuery } from '@tanstack/react-query';
import { relatedFilesQueryOption } from '@/common/queries/relatedFiles/relatedFilesQueryOption.ts';
import CircularLoading from '@/common/components/base/Loading/CircularLoading.tsx';
import FileAcceptCheckBoxCard from '@/modules/FileList/components/FileAcceptCheckBoxCard/FileAcceptCheckBoxCard.tsx';
import {
  FieldValues,
  FormProvider,
  SubmitHandler,
  useForm,
} from 'react-hook-form';
import { HasRelatedFileAcceptModalProps } from '@/modules/FileList/components/modals/acceptFileModals/AcceptFileModals.type.ts';

export default ({ closeModal, fileId }: HasRelatedFileAcceptModalProps) => {
  const { data, isPending } = useQuery(relatedFilesQueryOption({ id: fileId }));
  const { mutate, isPending: acceptFilePending } = useAcceptFileMutation();
  const methods = useForm();
  const { handleSubmit } = methods;

  if (!data || isPending) {
    return (
      <Center height="350px">
        <CircularLoading color="colors.purple-primary" />
      </Center>
    );
  }

  const getAcceptedFilesIds = (data: FieldValues) => {
    return Object.keys(data).flatMap((id) => {
      if (data[id]) {
        return +id;
      } else return [];
    });
  };

  const acceptFileSubmit: SubmitHandler<FieldValues> = (data) => {
    const acceptedFilesIds = getAcceptedFilesIds(data);
    mutate(
      {
        fileId,
        relatedFilesIds: acceptedFilesIds,
      },
      {
        onSuccess: closeModal,
      },
    );
  };
  return (
    <form onSubmit={handleSubmit(acceptFileSubmit)}>
      <Box>
        <Stack
          pb="15px"
          mb="15px"
          borderBottom="1px solid {colors.gray-2}"
          gap="20px"
          alignItems="center"
        >
          <CheckIcon />
          <Typography>آیا از قبول پرونده مطمئن هستید؟</Typography>
          <BulletTypography
            color="black-3"
            backgroundColor="green-3"
            textStyle="b2"
          >
            در صورت قبول ، پرونده به بخش پرونده‌های در حال اجرا منتقل می شود.
          </BulletTypography>
          <BulletTypography
            color="black-3"
            backgroundColor="green-3"
            textStyle="b2"
          >
            {data.relatedFiles.length} پرونده در ارتباط با این پرونده وجود دارد،
            در صورت تمایل نسبت به قبول این پرونده‌ها اقدام نمایید.
          </BulletTypography>
        </Stack>
        <FormProvider {...methods}>
          {data.acceptFileDetailCardItems.map((file, index) => (
            <FileAcceptCheckBoxCard
              key={data.relatedFiles[index].id}
              ListData={file}
              name={String(data.relatedFiles[index].id)}
            />
          ))}
        </FormProvider>
        <Flex my="20px" width="100%" gap="15px">
          <Button
            onClick={closeModal}
            fullWidth
            color="common"
            variant="outlined"
            type="button"
            disabled={acceptFilePending}
          >
            انصراف
          </Button>
          <LoadingButton loading={acceptFilePending} fullWidth>
            قبول پرونده
          </LoadingButton>
        </Flex>
      </Box>
    </form>
  );
};
